import {stations} from "./stations"
import * as turf from "@turf/turf";

/**
 * Operation needed to show the stations in order
 * @returns {*[]}
 */
export const translateStations = () => {

    const dots = [];
    stations.map((station) => {
        dots.push({
            order: station.order,
            id: station.id,
            name: station.name,
        })
    })
    return dots;
}

/**
 * In order to check the real distance
 * @returns {*[]}
 */
const getCenterOfEachStation = () => {
    const polygon_centers = [];
    stations.map((station) => {
        const polygon = turf.polygon(
            [[...station.area.coordinates[0].map(e => e.reverse())]],
            {
                station_id: station.id,
            });
        let center = turf.center(polygon).geometry.coordinates
        center = center[0] < 0 ? center : center.reverse();
        polygon_centers.push(turf.point(center, {
            station_id: station.id
        }));
    })
    return polygon_centers;
}

/**
 * Helper function to return the values in groups
 * @param values
 * @returns {*[]}
 */
const createGroupsOfPoints = (values) => {
    const groups = [];

    if (values.length === 0) {
        return groups;
    }

    values.map((point) => {
        if (groups[point.unit_id] === undefined) {
            groups[point.unit_id] = [];
        }
        groups[point.unit_id].push(point);
    })

    return groups;
}

/**
 * This function computes the orientation of each group
 * @param values
 * @returns {*[]}
 */
export const getOrientationOfEach = (values) => {

    const groups = createGroupsOfPoints(values);
    // console.log(groups);
    const orientations = [];

    // Get orientations
    groups.forEach((group, id) => {
        // Applying harvesine
        let [sX, sY] = [-99.1044664, 19.5256261]; // Pensión
        let orientation = -1; // -1 Sur 1 Norte
        if (group.length === 0) {
            if (orientations[id] === undefined) {
                orientations[id] = orientation;
            }
        }

        const reversedGroup = group.reverse();
        reversedGroup.forEach(point => {
            const coords = point.location.coordinates[0] < 0 ? point.location.coordinates : point.location.coordinates.reverse();
            const [x, y] = coords;
            if (x !== 0 && y !== 0) {
                if ( y < sY) {
                    orientation = -1
                }
                if ( y > sY) {
                    orientation = 1
                }
                // If still, is the same as before
                [sX, sY] = [x, y];
            }
            else {
                orientation = 1;
                [sX, sY] = [sX, sY];
                console.log("Error! Problem with GPS, " + point["unit_number"]);
            }
        })

        orientations[id] = orientation;
        // FYI: console.log(orientation === 1 ? 'norte' : 'sur');
    })

    return orientations;
}

/**
 * Get the nearest station
 * @param values
 * @returns {*[]}
 */
export const getNearestStation = (values) => {
    const groups = createGroupsOfPoints(values);

    let centers = [];
    groups.forEach((group, id) => {
        let raw_features = [];
        group.forEach(point => {
            raw_features.push(point.location.coordinates);
        })
        let features = turf.points(raw_features);
        centers[id] = turf.center(features);
    })

    const station_centers = getCenterOfEachStation();

    // Testing only
    // centers = [centers[1]];
    const unitWithNearStation = [];

    centers.forEach((center, id) => {
        let turfCenter = turf.point(center.geometry.coordinates);
        const distances = [];
        station_centers.forEach((station, id) => {
            let turfStationCenter = turf.point(station.geometry.coordinates);
            let distance = turf.distance(turfCenter, turfStationCenter, {units: "meters"});
            distances.push([distance, station.properties.station_id]);
        })

        const distanceColumn = distances.map(d => d[0]);
        const min = Math.min(...distanceColumn);
        const index = distanceColumn.indexOf(min);

        unitWithNearStation[id] = [min, distances[index][1]];
    })

    return unitWithNearStation;

}

/**
 * From an array of group of points we get the last of each one and returns
 * in a new array so the manipulation could be possible
 * @param points
 * @returns {*[]}
 */
export const getLastDataFromEachPoint = (points) => {
    const groupPoints = createGroupsOfPoints(points);
    const cleanPoints = [];
    groupPoints.map((group, i) => {
        const latest = group.reduce((a, b) => {
            return new Date(a.created_at) > new Date(b.created_at) ? a : b;
        });
        cleanPoints.push(latest);
    })
    return cleanPoints;
}

/**
 * Array of points which are blocking
 * @param points
 */
export const getBlockingPerUnit = (points) => {

    const pointsByGroup = createGroupsOfPoints(points);
    const blocks = [];
    pointsByGroup.map((threePoints, i) => {

        const sorted = threePoints.sort((a,b) => a.id - b.id);

        let initialBlockFront = parseInt(sorted[0].bf);
        let lastBlockFront = parseInt(sorted[sorted.length - 1].bf);
        let initialBlockBack = parseInt(sorted[0].bb);
        let lastBlockBack = parseInt(sorted[sorted.length - 1].bb);

        blocks.push({
            unit_id: sorted[0].unit_id,
            unit_number: parseInt(sorted[0].unit_number),
            blockBb: lastBlockBack - initialBlockBack,
            blockBf: lastBlockFront - initialBlockFront
        })
    })

    return blocks;


}